// eslint-disable-next-line prefer-destructuring
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const INSIDE_WEBVIEW =
  !!process.env.REACT_APP_INSIDE_WEBVIEW &&
  JSON.parse(process.env.REACT_APP_INSIDE_WEBVIEW);
export const VERSION = process.env.REACT_APP_VERSION;

const useDevEnvironment = process.env.NODE_ENV !== "production";

let AMPLITUDE_KEY = "0301bd476edf941223f4ca30fd8d8b70";
if (useDevEnvironment) {
  AMPLITUDE_KEY = "8005af98012d53e3c8332967b5eb7fe7";
}

const STICKER_ID = /^\w{6,}$/;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function stickerIdFromQr(qrPayload) {
  let url;
  try {
    url = new URL(qrPayload);
  } catch (ignored) {
    return null;
  }
  if (url.protocol !== "https:") {
    return null;
  }
  const host = url.hostname.toLowerCase();
  const [pathId] = url.pathname.split("/").filter(Boolean);
  if (
    host === "t.orda-app.com" ||
    host === "t-dev.orda-app.com" ||
    host === "personio.kitchen"
  ) {
    return pathId && STICKER_ID.test(pathId) ? pathId : null;
  }
  if (host === "web.orda-app.com" || host === "web-dev.orda-app.com") {
    const parts = url.pathname.split("/").filter(Boolean);
    if (
      parts.length !== 3 ||
      parts[0] !== "venues" ||
      parts[2] !== "menu" ||
      !UUID.test(parts[1])
    ) {
      return null;
    }
    const id = url.searchParams.get("qr");
    return id && STICKER_ID.test(id) ? id : null;
  }
  return null;
}
export const AMPLITUDE_API_KEY = AMPLITUDE_KEY;
